export const GET_NEXT_STEPS = 'nextStep/GET_NEXT_STEPS';
